package com.tovtalk.di

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.remember
import com.russhwolf.settings.Settings
import com.tovtalk.presentation.ScopedViewModel

@Composable
inline fun <reified T : Any> koinInject(): T = remember {
    getKoin().get()
}

/**
 * Like [koinInject], but for factory-scoped [ScopedViewModel]s: it disposes the resolved
 * instance (cancelling its injected CoroutineScope and all launched jobs/collectors) when
 * the calling composable leaves the composition. Use this for per-navigation ViewModels
 * (Profile / Chat / Comments / PostDetail / Onboarding) so they don't leak on every screen
 * visit. Do NOT use for `single`-scoped ViewModels (they're meant to live for the session).
 */
@Composable
inline fun <reified T> disposableKoinInject(): T where T : Any, T : ScopedViewModel {
    val vm = remember { getKoin().get<T>() }
    DisposableEffect(vm) {
        onDispose { vm.dispose() }
    }
    return vm
}

/**
 * Initializes TokenManager with Settings from Koin (e.g. from localStorage on Web).
 * Call after startKoin() on Web so the token is loaded before the first frame and the user stays logged in after refresh.
 */
fun initTokenManagerFromKoin() {
    com.tovtalk.data.local.TokenManager.init(getKoin().get<Settings>())
    com.tovtalk.utils.logger.Logger.d(
        "initTokenManagerFromKoin: hasAccessToken=${com.tovtalk.data.local.TokenManager.accessToken != null}",
        "KoinExt"
    )
}
